export default "__VITE_ASSET__BSX5cZFr__"